async function replaceCartThumbnails() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const rows = [...document.querySelectorAll('.cart__items__row[data-cart-item-key]')];

    cart.items.forEach(item => {
      const customImg = item.properties?._customization_image;
      if (customImg) {
        const row = rows.find(candidate => candidate.dataset.cartItemKey === item.key);
        if (row) {
          const imgEl = row.querySelector('.cart__items__image img');
          if (imgEl) {
            imgEl.src = customImg;
          }
        }
      }
    });
  } catch (err) {
    console.error("replaceCartThumbnails error:", err);
  }
}

(function(){
  const target = document.querySelector('#drawer-cart');
  if (!target) return;

  let refreshTimer;
  const scheduleThumbnailRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(replaceCartThumbnails, 50);
  };

  const observer = new MutationObserver(mutations => {
    if (!target.classList.contains('drawer--visible')) return;

    const shouldRefresh = mutations.some(mutation =>
      (mutation.type === 'attributes' && mutation.target === target && mutation.attributeName === 'class') ||
      (mutation.type === 'childList' && (
        mutation.target.matches?.('[data-line-items]') ||
        [...mutation.addedNodes].some(node =>
          node.nodeType === Node.ELEMENT_NODE && (
            node.matches?.('[data-line-items]') ||
            node.querySelector?.('[data-line-items]')
          )
        )
      ))
    );

    if (shouldRefresh) scheduleThumbnailRefresh();
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });
})();
